// eslint-disable-next-line no-shadow
export enum BannerSeverity {
  Info = 0,
  Warning = 1,
  Error = 2,
}
